var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-gallery" },
    [
      _c("h2", { staticClass: "product-gallery__title" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
      ]),
      _c("swiper", {
        staticClass: "product-gallery",
        attrs: {
          items: _vm.products,
          "slides-to-show": _vm.slidesToShow,
          dots: "",
          arrows: _vm.adaptive.isDesktop
        },
        on: { change: _vm.onChangeSlide },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var item = ref.item
              return [_c("product-list-item", { attrs: { product: item } })]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }